import { Backdrop, Box, Card, CardContent, CardHeader, CircularProgress, Checkbox, Chip, Container, Divider, Grid, Snackbar, Table, TableCell, TableContainer, TableBody, TableHead, TableRow, TextField, InputAdornment, IconButton, Typography, Button, TablePagination, Autocomplete, Stack, Tooltip } from '@mui/material';
import Alert from 'src/components/Alert';
import React, { useState, useEffect } from 'react';
import { getUser } from 'src/utils/Common';
import Page from 'src/components/Page';
import { useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import axios from 'src/utils/axios';

import SearchIcon from '@mui/icons-material/Search';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import RestartAltIcon from '@mui/icons-material/RestartAlt';


const styles = {
  root: (theme) => ({
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  }),
  rootlist: (theme) => ({
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 550
  }),
  rootlistsag: (theme) => ({
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 500
  }),

  cardBolum: {
    maxHeight: 700,
    minHeight: 700,
    width: '100%'
  },
  table: {
    minWidth: 650
  },
  content: {
    minHeight: 550
  },
  chatSection: {
    width: '100%'
  },
  avatar: {
    cursor: 'pointer',
    width: 40,
    height: 40
  },
  headBG: {
    backgroundColor: '#e0e0e0'
  },
  borderRight500: {
    borderRight: '1px solid #e0e0e0'
  },
  messageArea: {
    overflowY: 'auto'
  },
  button: (theme) => ({
    margin: theme.spacing(1)
  }),
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }),
  actionsCCFile: {
    justifyContent: 'flex-end'
  },
  responsiveContainer: (theme) => ({
    marginTop: theme.spacing(3),
    [theme.breakpoints.between('md', 'lg')]: {
      maxHeight: '70vh',
      overflowX: 'hidden',
      overflowY: 'scroll'
    },
    [theme.breakpoints.down('sm')]: {
      maxHeight: '60vh',
      overflow: 'scroll'
    }
  }),
  action: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: '16px',
    marginRight: '10px',
    borderRadius: 10,
  },
  switch_track: {
    backgroundColor: "#263238",
  },
  switch_base: {
    color: '#FF9800',
    "&.Mui-disabled": {
      color: '#FF9800'
    },
    "&.Mui-checked": {
      color: "#FF9800"
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#263238",
    }
  },
  switch_primary: {
    "&.Mui-checked": {
      color: "#263238",
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#263238",
    },
  },
  closeButton: (theme) => ({
    position: 'absolute',
    right: theme.spacing(0),
    top: theme.spacing(-1),
    color: theme.palette.grey[500],
  }),
};

function JointService() {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const SessionUser = getUser();

  const [responseMessage, setresponseMessage] = useState(
   "" 
  );

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const [bolgeAdiKodu, setBolgeAdiKodu] = React.useState([]);
  const [BirimData, setBirimData] = React.useState([]);
  const [selectedbolgeAdiKodu, setSelectedbolgeAdiKodu] = React.useState([]);
  const [SelectedBirim, setSelectedBirim] = React.useState([]);
  
  const [openEditDialog, setOpenEditDialog] = React.useState(false);
  const [selectedRowForEdit, setSelectedRowForEdit] = React.useState(null);


  const [employeeReportData, setEmployeeReportData] = React.useState([]);
  const [pg, setpg] = React.useState(0);
  const [rpg, setrpg] = React.useState(10);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const selectAllIcon = <PlaylistAddCheckIcon fontSize="small" />;

  const SelectAllOption = { Id: -1, Dsc: 'Tümünü Seç' };
  const [openDialog, setOpenDialog] = React.useState(false);
  useEffect(() => {
    getBolgeAdiKoduData();

  }, []);

  const [Bolge, setBolge] = useState([]);
  const [Servis, setServis] = useState('');
  const [JointServis, setJointServis] = useState('');
  const [JointRate, setJointRate] = useState('');
  const [Desc, setDesc] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSaveData = (OperationType) => {
    if (OperationType === 'I' && !Servis?.BirimKodu) {
      setUyariTip('warning');
      setresponseMessage('Lütfen servis seçiniz!...');
      setUyari(true);
      return;
    }
    if (OperationType === 'I' && !JointServis) {
      setUyariTip('warning');
      setresponseMessage('Lütfen nakliye montaj servis kodu giriniz!...');
      setUyari(true);
      return;
    }
    if (!JointRate) {
      setUyariTip('warning');
      setresponseMessage('Lütfen ortaklık payı giriniz!...');
      setUyari(true);
      return;
    }

    const requestData = {
      "Bolge": Bolge[0].BirimKodu,
      "ServiceKulCode":  selectedRowForEdit ? selectedRowForEdit.SERVIS_KODU : Servis.BirimKodu,
      "JointServiceKulCode":  selectedRowForEdit ? selectedRowForEdit.NAKLIYE_MONTAJ_SERVIS_KODU : JointServis,
      "JointRate": JointRate,
      "Description": Desc,
      "Type" : OperationType

    };
    setSaving(true);
    axios.post('SetServiceJoint', requestData)
      .then(response => {
        setSaving(false);
        if(response.data.ErrorCode == 0 )
        {
          setUyariTip("success");
          setOpenDialog(false);
          setOpenEditDialog(false);
          setSelectedRowForEdit(null);
          getReport();
        }
        else
        {
          setUyariTip("error");
        }
        setresponseMessage(response.data.ErrorDescription);
        setUyari(true);

        // Reset input fields after successful submission if needed
        setBolge(bolgeAdiKodu.filter(x => x?.BirimKodu == SessionUser.TopServiceShopCode));
        setServis('');
        setJointServis('');
        setJointRate('');
        setDesc('');
        // ... reset other fields if needed
      })
      .catch(error => {
        setSaving(false);
        setUyariTip("error");
        setresponseMessage("Bir hata meydana geldi, daha sonra tekrar deneyiniz.");
        setUyari(true);
      });
  }


  const getBolgeAdiKoduData = () => {
    axios.get(`GetBolgeAdiKodu/${SessionUser.TopServiceShopCode}`).then((response) => {
      setBolgeAdiKodu(response?.data?.filter(x => x?.BirimKodu !== '0'));
      setSelectedbolgeAdiKodu(response?.data?.filter(x => x?.BirimKodu == SessionUser.TopServiceShopCode));
      getBirimData([SessionUser.TopServiceShopCode]);
      setBolge(response?.data?.filter(x => x?.BirimKodu == SessionUser.TopServiceShopCode));
    })

  }

  const getBirimData = (BirimKodu) => {
    if (!BirimKodu || BirimKodu.length < 1) {
      setBirimData([]);
    } else {
      setLoading(true);
      axios.get(`GetBirimDataCokBolgeli?BirimKodu=${BirimKodu.join("&BirimKodu=")}`).then((response) => {
        setBirimData(response.data);
        setLoading(false);
      });
    }
  }


  const getReport = () => {
    setLoading(true);
    const birimKoduQuery = !SelectedBirim || SelectedBirim.length < 1 ? '0' : SelectedBirim?.map(x => x.BirimKodu).join("&BirimKodu=");
    const bolgeKoduQuery = !selectedbolgeAdiKodu || selectedbolgeAdiKodu.length < 1 ? '0' : selectedbolgeAdiKodu?.map(x => x.BirimKodu).join("&BolgeKodu=");
    axios.get(`GetServiceJoint?BolgeKodu=${bolgeKoduQuery}&BirimKodu=${birimKoduQuery}`).then((response) => {
      setEmployeeReportData(Array.isArray(response.data) ? response.data : []);
      setLoading(false);
    }).catch(error => {
      setLoading(false);
    });
  }

  function handleChangePage(event, newpage) {
    setpg(newpage);
  }

  function handleChangeRowsPerPage(event) {
    setrpg(parseInt(event.target.value, 10));
    setpg(0);
  }

  const clearAllInputs = () => {
    setSelectedbolgeAdiKodu([]);
    setSelectedBirim([]);
    setEmployeeReportData([]);
    setpg(0);
    setrpg(10);
  }



  const renderOption = (props, option, { selected }) => (
    option.Id !== -1 ?
      (<li {...props}>
        <Checkbox
          icon={icon}
          checkedIcon={checkedIcon}
          style={{ marginRight: 8 }}
          checked={selected}
        />
        {option.Dsc}
      </li>)
      : (<li {...props}>
        <Checkbox
          icon={selectAllIcon}
          checkedIcon={selectAllIcon}
          style={{ marginRight: 8 }}
          checked={selected}
        />
        {option.Dsc}
      </li>)
  );
  const handleOpenNewApplicationDialogUser = () => {
    setServis('');
    setJointServis('');
    setJointRate('');
    setDesc('');
    setOpenDialog(true);
  };

  const handleCloseNewApplicationDialogUser = () => {
    setOpenDialog(false);
  };

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
    setSelectedRowForEdit(null);
    setJointRate('');
    setDesc('');
  };

  const handleUpdateClick = (row) => {
    setSelectedRowForEdit(row);
    setJointRate(row.ORTAKLIK_PAY || '');
    setDesc(row.ACIKLAMA || '');
    setOpenEditDialog(true);
  };

  return (
    <Page sx={styles.root}>
      <Backdrop sx={styles.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={uyari}
        autoHideDuration={10000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={uyariKapat} variant={uyariTip} message={responseMessage}
        ></Alert>
      </Snackbar>
      <Container sx={styles.container1} maxWidth="xl">
        <Card>
          <CardHeader title="Nakliye Montaj Servisleri" />
          <Divider />
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '18px' }}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<AddBusinessIcon />}
                onClick={handleOpenNewApplicationDialogUser}
                style={{ textTransform: 'none' }}
              >
                Yeni Servis Ekle
              </Button>
            </Box>

            <Dialog open={openEditDialog} onClose={handleCloseEditDialog} fullWidth maxWidth="sm">
              <DialogTitle style={{ textAlign: 'center' }}>
                Ortaklık Kaydını Düzenle
                <IconButton
                  onClick={handleCloseEditDialog}
                  aria-label="close"
                  sx={styles.closeButton}
                  component="span"
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <Divider />
              <DialogContent>
        {selectedRowForEdit && (
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                size="small"
                label="Bölge"
                variant="outlined"
                value={selectedRowForEdit.BOLGE || ""}
                disabled
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                size="small"
                label="Servis"
                variant="outlined"
                value={selectedRowForEdit.SERVIS || ""}
                disabled
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                size="small"
                label="Nakliye Montaj Servis Kodu"
                variant="outlined"
                value={selectedRowForEdit.NAKLIYE_MONTAJ_SERVIS_KODU || ""}
                disabled
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                size="small"
                label="Nakliye Montaj Servis"
                variant="outlined"
                value={selectedRowForEdit.NAKLIYE_MONTAJ_SERVIS || ""}
                disabled
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                required
                size="small"
                label="Ortaklık Payı"
                variant="outlined"
                type="number"
                value={JointRate}
                onChange={(e) => setJointRate(e.target.value)}
                InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                size="small"
                label="Not"
                variant="outlined"
                value={Desc}
                onChange={(e) => setDesc(e.target.value)}
              />
            </Grid>
          </Grid>
        )}
              </DialogContent>
              <Divider />
              <DialogActions sx={{ pr: 2.5 }}>
                <Button onClick={handleCloseEditDialog} variant="outlined" color="secondary" style={{ textTransform: 'none' }}>
                  İptal
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={saving}
                  style={{ textTransform: 'none' }}
                  onClick={() => handleSaveData('U')}
                >
                  {saving ? 'Kaydediliyor...' : 'Kaydet'}
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog open={openDialog} onClose={handleCloseNewApplicationDialogUser} fullWidth maxWidth="sm">
              <DialogTitle style={{ textAlign: 'center' }}>
                Yeni Nakliye Montaj Servisi Ekle
                <IconButton
                  onClick={handleCloseNewApplicationDialogUser}
                  aria-label="close"
                  sx={styles.closeButton}
                  component="span"
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <Divider />
              <DialogContent>
                <Grid container spacing={2} sx={{ mt: 0.5 }}>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      size="small"
                      id="combo-box-demo"
                      fullWidth
                      value={Bolge}
                      options={bolgeAdiKodu.length > 0 ? bolgeAdiKodu : []}
                      getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                      renderOption={renderOption}
                      onChange={(event, newValue) => {
                        setBolge(newValue);
                      }}
                      renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined" />}
                      disabled
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Autocomplete
                      size="small"
                      id="combo-box-demo"
                      fullWidth
                      value={Servis}
                      options={BirimData}
                      getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                      onChange={(event, newValue) => {
                        setServis(newValue);
                      }}
                      renderInput={(params) => <TextField {...params} label="Servis *" variant="outlined" />}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      fullWidth
                      required
                      size="small"
                      label="Nakliye Montaj Servis Kodu"
                      variant="outlined"
                      value={JointServis}
                      onChange={(e) => setJointServis(e.target.value)}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      fullWidth
                      required
                      size="small"
                      label="Ortaklık Payı"
                      variant="outlined"
                      type="number"
                      value={JointRate}
                      onChange={(e) => setJointRate(e.target.value)}
                      InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
                    />
                  </Grid>
                  <Grid size={{ xs: 12 }}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Not"
                      variant="outlined"
                      value={Desc}
                      onChange={(e) => setDesc(e.target.value)}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <Divider />
              <DialogActions sx={{ pr: 2.5 }}>
                <Button onClick={handleCloseNewApplicationDialogUser} variant="outlined" color="secondary" style={{ textTransform: 'none' }}>
                  İptal
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={saving}
                  style={{ textTransform: 'none' }}
                  onClick={() => handleSaveData('I')}
                >
                  {saving ? 'Kaydediliyor...' : 'Kaydet'}
                </Button>
              </DialogActions>
            </Dialog>

            <Grid container spacing={2}>
              <Grid
                size={{
                  xs: 12,
                  sm: 12,
                  lg: 6
                }}>
                <Autocomplete
                  multiple
                  limitTags={1}
                  size="small"
                  id="combo-box-demo"
                  fullWidth
                  value={selectedbolgeAdiKodu}
                  options={bolgeAdiKodu.length > 0 ? [SelectAllOption, ...bolgeAdiKodu] : []}
                  getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                  renderOption={renderOption}
                  onChange={(event, newValue) => {
                    newValue?.find(x => x.Id == -1) ? setSelectedbolgeAdiKodu(bolgeAdiKodu) : setSelectedbolgeAdiKodu(newValue);
                    var bolgeKodu = newValue?.find(x => x.Id == -1) ? bolgeAdiKodu.map(x => x.BirimKodu) : newValue.map(x => x.BirimKodu);
                    getBirimData(bolgeKodu);
                    setSelectedBirim([]);
                  }}
                  renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined" />}
                  disabled
                />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 12,
                  lg: 6
                }}>
                <Autocomplete
                  multiple
                  size="small"
                  id="combo-box-demo"
                  fullWidth
                  value={SelectedBirim}
                  options={BirimData.length > 0 ? [SelectAllOption, ...BirimData] : []}
                  getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                  renderOption={renderOption}
                  onChange={(event, newValue) => {
                    newValue?.find(x => x.Id == -1) ? setSelectedBirim(BirimData) : setSelectedBirim(newValue);
                  }}
                  renderTags={(tagValue, getTagProps) => {
                    if (BirimData.length > 0 && tagValue.length === BirimData.length) {
                      return <Chip size="small" label={`Tümü (${tagValue.length})`} {...getTagProps({ index: 0 })} />;
                    }
                    const visibleCount = 1;
                    return (
                      <>
                        {tagValue.slice(0, visibleCount).map((option, index) => (
                          <Chip size="small" key={option.Id ?? index} label={option.Dsc} {...getTagProps({ index })} />
                        ))}
                        {tagValue.length > visibleCount && (
                          <Chip size="small" variant="outlined" label={`+${tagValue.length - visibleCount}`} />
                        )}
                      </>
                    );
                  }}
                  renderInput={(params) => <TextField {...params} label="Servis" variant="outlined" />}

                />
              </Grid>
              <Grid size={12}>
                <Stack direction="row" spacing={1} justifyContent="flex-end">
                  <Tooltip title="Filtreleri temizle">
                    <Button
                      variant="outlined"
                      color="secondary"
                      startIcon={<RestartAltIcon />}
                      onClick={clearAllInputs}
                      style={{ textTransform: 'none' }}
                    >
                      Temizle
                    </Button>
                  </Tooltip>
                  <Tooltip title="Seçili filtrelerle ara">
                    <Button
                      variant="contained"
                      color="secondary"
                      startIcon={<SearchIcon />}
                      onClick={() => {
                        getReport();
                      }}
                      style={{ textTransform: 'none' }}
                    >
                      Ara
                    </Button>
                  </Tooltip>
                </Stack>
              </Grid>
            </Grid>
            <TableContainer sx={[styles.responsiveContainer, { maxHeight: 560, overflow: 'auto' }]}>
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead style={{ overflowWrap: 'break-word' }}>
                  <TableRow>
                    <TableCell align="left" />
                    <TableCell align="left">Bölge</TableCell>
                    <TableCell align="left">NM Servis Kodu </TableCell>
                    <TableCell align="left">NM Servis Adı</TableCell>
                    <TableCell align="left">Ortak</TableCell>
                    <TableCell align="left">Ortaklık Pay</TableCell>
                    <TableCell align="left">Ortaklık Başlangıç</TableCell>
                    <TableCell align="left">Ortaklık Bitiş</TableCell>
                    <TableCell align="left">NM Kapanış Tarihi</TableCell>
                    <TableCell align="left">Açıklama</TableCell>
                    <TableCell align="left">Log</TableCell>
                    <TableCell align="left" />
                  </TableRow>
                </TableHead>


                <TableBody>
                  {employeeReportData.length > 0 ? employeeReportData.slice(pg * rpg, pg * rpg + rpg).map((row, index) => (
                    <TableRow
                      key={row.Id}
                      sx={{ '&:nth-of-type(odd)': { backgroundColor: 'action.hover' } }}
                    >
                          <TableCell align="left">
                          <Tooltip title="Kaydı düzenle">
                            <Button variant="outlined" color="secondary" size="small" startIcon={<EditIcon />} style={{ textTransform: 'none' }} onClick={() => handleUpdateClick(row)}>
                              Düzenle
                            </Button>
                          </Tooltip>
                        </TableCell>
                      <TableCell align="left">{row.BOLGE || "-"}</TableCell>
                      <TableCell align="left">{row.NM_BIRIM_KODU || "-"}</TableCell>
                      <TableCell align="left">{row.NM_AD || "-"}</TableCell>
                      <TableCell align="left">{row.ORTAK || "-"}</TableCell>
                      <TableCell align="left">{row.ORTAKLIK_PAY || "-"}</TableCell>
                      <TableCell align="left">{row.ORTAKLIK_BASLANGIC || "-"}</TableCell>
                      <TableCell align="left">{row.ORTAKLIK_BITIS || "-"}</TableCell>
                      <TableCell align="left">{row.NM_KAPANIS_TARIHI || "-"}</TableCell>
                      <TableCell align="left">{row.ACIKLAMA || "-"}</TableCell>
                      <TableCell align="left">{row.KULLANICI_LOG || "-"}</TableCell>
                      <TableCell align="left" />
                    </TableRow>
                  )) : (
                    <TableRow>
                      <TableCell colSpan={12} align="center">
                        <Typography color="text.secondary" sx={{ py: 3 }}>Kayıtlı ortaklık bulunmamaktadır.</Typography>
                      </TableCell>
                    </TableRow>
                  )}

                </TableBody>

              </Table>
            </TableContainer>
            {employeeReportData.length > 0 &&
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={employeeReportData.length}
                rowsPerPage={rpg}
                page={pg}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            }
          </CardContent>
        </Card>
      </Container>
    </Page >
  );
}
export default JointService;
